import React, { Component } from "react";
import { connect } from "react-redux";
import EditableText from "../../../../common/editableText/index";

import "../../customize.scss";

export class ConcessionEditor extends Component {
    constructor(props) {
        super(props);

        this.state = {
            languageCode: this.props.data.languageCode
        };
    }

    handleUpdate = (index, tag, value, tagIndex) => {
        this.props.events.handleUpdate(this.props.data.itinerary, this.props.data.concession, index, tag, value, tagIndex);
    };

    render() {
        let { languageCode } = this.state;
        let concession = this.props.data?.concession;
        
        if(!concession) return null;
        let itineraryNumber = this.props.data?.itinerary?.itineraryNumber || "0";
        let concessionIndex = this.props.data?.concession?.concessionIndex || "0";

        return (
            <EditableText languageCode={languageCode} placeHolderObjects={concession?.placeHolderObjects || []} allEditable={true} enable={concession.included || false} prefixKey={itineraryNumber + "-" + concessionIndex} text={concession.concessionDisplayText} handleUpdate={this.handleUpdate}/>
        );
    }
}

const mapStateToProps = (state) => ({
    customQuote: state.customQuote
});

export default connect(mapStateToProps)(ConcessionEditor);
